export const required = value => value !== undefined || value !== null 
  ? undefined
  : `Required field`

export const max = max => value =>
  value && value > max ? `Value must be maximum ${max}` : undefined


// WEBPACK FOOTER //
// ./src/views/utils/validations.js